import { APIService } from "../../../../../../network/api/APIService";

export const DashboardUsersData = ({limit=null}) => {
    let endpoint = `/dashboard/users/?limit=${limit}`;

    return APIService({
        endpoint: endpoint,
        method: "GET",
        credentials: "include"
    });
}